module.exports = __webpack_public_path__ + "static/media/shape4.0b3672a1.svg";